import {Pipe, PipeTransform} from '@angular/core';
import {FileFormatService} from "./file-format.service";

@Pipe({
    name: 'fileExt'
})
export class FileExtPipe implements PipeTransform {
    constructor(private formatService: FileFormatService) {
    }

    transform(name: string): string {
        return this.formatService.getExtByName(name);
    }
}
